import React from "react";

const FileTextIcon = ({ className = "", width = 16, height = 18, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.47667 1.64464C0.5 2.62047 0.5 4.19214 0.5 7.33464V10.668C0.5 13.8105 0.5 15.3821 1.47667 16.358C2.45333 17.3338 4.02417 17.3346 7.16667 17.3346H8.83333C11.9758 17.3346 13.5475 17.3346 14.5233 16.358C15.4992 15.3813 15.5 13.8105 15.5 10.668V7.33464C15.5 4.19214 15.5 2.62047 14.5233 1.64464C13.5467 0.668802 11.9758 0.667969 8.83333 0.667969H7.16667C4.02417 0.667969 2.4525 0.667969 1.47667 1.64464ZM4.66667 6.70964C4.50091 6.70964 4.34193 6.77548 4.22472 6.89269C4.10751 7.0099 4.04167 7.16887 4.04167 7.33464C4.04167 7.5004 4.10751 7.65937 4.22472 7.77658C4.34193 7.89379 4.50091 7.95964 4.66667 7.95964H11.3333C11.4991 7.95964 11.6581 7.89379 11.7753 7.77658C11.8925 7.65937 11.9583 7.5004 11.9583 7.33464C11.9583 7.16887 11.8925 7.0099 11.7753 6.89269C11.6581 6.77548 11.4991 6.70964 11.3333 6.70964H4.66667ZM4.66667 10.043C4.50091 10.043 4.34193 10.1088 4.22472 10.226C4.10751 10.3432 4.04167 10.5022 4.04167 10.668C4.04167 10.8337 4.10751 10.9927 4.22472 11.1099C4.34193 11.2271 4.50091 11.293 4.66667 11.293H8.83333C8.99909 11.293 9.15806 11.2271 9.27527 11.1099C9.39248 10.9927 9.45833 10.8337 9.45833 10.668C9.45833 10.5022 9.39248 10.3432 9.27527 10.226C9.15806 10.1088 8.99909 10.043 8.83333 10.043H4.66667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FileTextIcon; 